export const OLD_API_LIST_FIRST_PAGE = 1

export const OLD_API_LIST_PAGE_STEP = 1
